// extracted by mini-css-extract-plugin
export default {"searchTermGroupContainer":"searchTermGroupSearch_searchTermGroupContainer__HQxnr"};